export const MODE = process.env.NODE_ENV;
// Hostname is retrieved from the browser or from the dedicated env var (used for development purpose)
export const HOSTNAME = `${process.env.REACT_APP_BACKEND_HOSTNAME || (typeof window !== "undefined" && window.location.host)}`;
export const REST_API_URL = `//${HOSTNAME}`;
export const LOGIN_AUTH_URL = `${REST_API_URL}/auth/google`;
export const LOGOUT_AUTH_URL = `${REST_API_URL}/auth/logout`;
export const GRAPHQL_ENDPOINT = `${REST_API_URL}/graphql`;
